export const FlatButton = ({className, title, children, onClick}) => {
    className = className ? `${className} button flat-button` : "button flat-button"
    return <button className={className} onClick={onClick}>
        {title}
        {children}
    </button>
}